import React from 'react';

/**
 * PhotoPlaceholder component that renders a placeholder for photos without thumbnails
 * while preserving the correct aspect ratio based on the photo's dimensions.
 * 
 * @param {Object} props - Component props
 * @param {number} props.width - Photo width in pixels
 * @param {number} props.height - Photo height in pixels
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.forceSquare - If true, ignores aspect ratio to maintain square shape for grid consistency
 */
export default function PhotoPlaceholder({ width, height, className = '', forceSquare = false }) {
  const aspectRatio = width && height ? width / height : 1;
  const hasValidDimensions = width && height;
  const shouldUseAspectRatio = hasValidDimensions && !forceSquare;
  
  return (
    <div 
      className={`bg-gray-50 border-2 border-dashed border-gray-300 flex items-center justify-center text-gray-400 ${className}`}
      style={shouldUseAspectRatio ? { aspectRatio: aspectRatio.toString() } : {}}
    >
      <div className="text-center">
        <svg 
          className="w-12 h-12 sm:w-16 sm:h-16 mx-auto mb-2" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
          role="img"
          aria-label="Photo placeholder"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={1} 
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" 
          />
        </svg>
        {hasValidDimensions && (
          <div className="text-xs text-gray-500 font-mono">
            {width}×{height}
          </div>
        )}
      </div>
    </div>
  );
}
